export default "__VITE_PUBLIC_ASSET__60368910__"